import FilterBar from './FilterBar.jsx';

export default FilterBar;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/index.js